<template>
  <div>
    <el-dialog title="需求建议" :visible.sync="commentFormState" width="30%">
      <el-form ref="form" :model="commentForm" label-width="80px">
        <el-form-item label="内容">
          <el-input type="textarea" v-model="commentForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="commentForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="内容类型">
          <el-radio-group v-model="commentForm.type" style="margin-left: -15%;">
            <el-radio label="1">评论</el-radio>
            <el-radio label="2">反馈</el-radio>
            <el-radio label="3">建议</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCommon">提交</el-button>
          <el-button @click="commentFormState=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="会员等级升级" :visible.sync="memberUpgradeState" width="30%">
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <el-select v-model="memberUpgradeForm.vip_type" placeholder="请选择要升级的等级" @change="calculatePriceDifference">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
        <div v-if="upgradeInformation.days">
          <div style="margin-top: 30px;">剩余<span
            style="color: #F56C6C;font-size: 20px;font-weight: bold;">{{ upgradeInformation.days }}</span>天,需补差价:￥<span
            style="color: #F56C6C;font-size: 20px;font-weight: bold;">{{ upgradeInformation.price }}</span></div>
          <div style="font-size: 12px;color: #909399;margin-top: 10px;">*{{ upgradeInformation.message }}</div>
        </div>
        <el-button type="primary" round style="margin-top: 30px;width: 50%;" :disabled="confirmDisabled"
                   @click="generateUpgradeOrder">确 定 升 级
        </el-button>
      </div>

    </el-dialog>

    <el-dialog
      title="扫码付费"
      :visible.sync="showState"
      width="30%"
      @close="cancelOrderPay"
      center>
      <div style="display: flex;flex-direction: column;align-items: center;">
        <img :src="payData.paySrc" alt="">
        <div style="font-size: 30px;font-weight: bold;color: #000;">￥{{ payData.orderInfo.amount }}</div>
        <div style="margin-top: 10px;">打开"微信"扫码支付</div>
        <el-button style="margin-top: 20px;" type="primary" @click="checkOrderPayState">已完成支付</el-button>
      </div>
    </el-dialog>

    <!--批量导入弹出层-->
    <el-dialog title="批量导入" @close="closeImportDialog" :visible.sync="importState" style="text-align: center;">
      <el-upload
        class="upload-demo"
        drag
        name="file"
        action="https://teamapi.youlupei.com/place/HDGExcelImport"
        :headers="uploadHeaders"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :multiple="false">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过1000行地点</div>
      </el-upload>
      <el-link style="margin-top: 30px;" type="warning" :href="link" v-if="link">点击查看导入失败的地点</el-link>
      <el-link style="margin-top: 30px;" type="success" href="/static/团队地点库模板.xlsx" v-else>下载模板</el-link>

    </el-dialog>
    <!--批量导入弹出层-->
  </div>
</template>

<script>
import {SaveCommon} from '../api/system.js'
import {CalculatePriceDifference, GenerateUpgradeOrder, QueryOrderPayState} from '../api/member.js'

export default {
  name: 'Common',
  props: {
    options: {
      type: Array
    },
    commentFormState: {
      type: Boolean,
      default: false
    },
    memberUpgradeState: {
      type: Boolean,
      default: false
    },
    importState: {
      type: Boolean,
      default: false
    },
    uploadHeaders:{
      type: Array
    }
  },
  data () {
    return {
      link:null,
      commentForm: {},
      memberUpgradeForm: {},
      upgradeInformation: {},
      confirmDisabled: true,
      showState: false,
      payData: {
        paySrc: '',
        orderInfo: {},
        interval: {},
        intervalNum: 0
      }
    }
  },
  methods: {
    saveCommon () {
      var that = this
      SaveCommon(that.commentForm).then(res => {
        if (res.code === 200) {
          that.dialogTableVisible = false
          that.$notify({
            type: 'success',
            message: '提交成功'
          })
        } else {
          that.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    calculatePriceDifference () {
      var that = this
      CalculatePriceDifference(this.memberUpgradeForm).then(res => {
        if (res.code === 200) {
          that.upgradeInformation = res.data
          that.confirmDisabled = false
        }
      })
    },
    generateUpgradeOrder () {
      var that = this
      GenerateUpgradeOrder(this.memberUpgradeForm).then(res => {
        if (res.code === 200) {
          if (res.code === 200) {
            that.memberUpgradeState = false
            that.showState = true
            that.payData.paySrc = 'data:image/png;base64,' + res.data.qrcode
            that.payData.orderInfo = res.data.orderInfo
            that.payData.interval = setInterval(that.queryOrderPayState, 3000)
          } else {
            that.$notify({
              title: '系统通知',
              message: res.message,
              type: 'error',
              offset: 100
            })
          }
        }
      })
    },
    cancelOrderPay () {
      this.showState = false
      this.payData.paySrc = ''
      this.payData.orderInfo = {}
      clearInterval(this.payData.interval)
    },
    checkOrderPayState () {
      var that = this
      var params = {order_sn: this.payData.orderInfo.order_sn}
      QueryOrderPayState(params).then(res => {
        if (res.code === 200) {
          if (that.payData.interval) {
            clearInterval(that.payData.interval)
          }
          that.showState = false
          that.payData.orderInfo = {}
          that.$notify({
            title: '系统通知',
            message: '支付成功',
            type: 'success',
            offset: 100
          })
        } else if (res.code === 1501) {
          that.$notify({
            title: '系统通知',
            message: res.message,
            type: 'error',
            offset: 100
          })
        } else {
          if (that.payData.interval) {
            clearInterval(that.payData.interval)
          }
          that.showState = false
          that.payData.orderInfo = {}
          that.$notify({
            title: '系统通知',
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    queryOrderPayState () {
      var that = this
      if (that.payData.intervalNum >= 900) { // 长时间未支付处理
        clearInterval(that.payData.interval)
        that.showState = false
        that.payData.orderInfo = {}
        that.$notify({
          title: '系统通知',
          message: '超过30分钟未支付,请重新支付!',
          type: 'warning',
          offset: 100
        })
        return
      }
      var params = {order_sn: this.payData.orderInfo.order_sn}
      QueryOrderPayState(params).then(res => {
        if (res.code === 200) {
          if (that.payData.interval) {
            clearInterval(that.payData.interval)
          }
          that.showState = false
          that.payData.orderInfo = {}
          that.payData.paySrc = ''
          that.$notify({
            title: '系统通知',
            message: '支付成功',
            type: 'success',
            offset: 100
          })
        } else if (res.code === 1501) {
          that.payData.intervalNum++
        } else {
          if (that.payData.interval) {
            clearInterval(that.payData.interval)
          }
          that.showState = false
          that.payData.orderInfo = {}
          that.$notify({
            title: '系统通知',
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },

    uploadSuccess (res) {
      if (res.code === 200) {
        if (res.data.link === '') {
          this.$notify({
            type: 'success',
            message: '导入成功'
          })
        } else {
          this.$notify({
            type: 'success',
            message: '部分导入成功,部分失败',
            offset: 80
          })
          this.link = res.data.link
        }
      } else {
        this.$notify({
          type: 'error',
          message: res.message,
          offset: 80
        })
      }
    },
    uploadError (err) {
      this.$notify.error(err)
    },
    closeImportDialog(){
      this.$parent.importState = false
      this.importState = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common.vue